import React from "react";
import { Select } from "@shopify/polaris";
import { useCollections } from "../../../api_utils/requests";

interface CollectionSelectProps {
  readonly collectionTitle: string | undefined;
  readonly setCollectionTitle: (collectionTitle: string) => void;
}

export function CollectionSelect({ collectionTitle, setCollectionTitle }: CollectionSelectProps): React.ReactElement {
  const { data: collections, isLoading } = useCollections();

  const options = React.useMemo(() => {
    const collectionOptions = collections.map((collection) => ({
      label: collection,
      value: collection,
    }));

    return [{ label: "All collections", value: "" }, ...collectionOptions];
  }, [collections]);

  return (
    <Select
      disabled={isLoading}
      label="Collection"
      onChange={setCollectionTitle}
      options={options}
      value={collectionTitle || ""}
    />
  );
}
